import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import type { SuggestionsResponse } from "@/lib/types";

import { fetchSuggestions } from "@/lib/api";

export function useSuggestions(limit = 4): UseQueryResult<SuggestionsResponse> {
  return useQuery({
    queryKey: ["suggestions", limit],
    queryFn: () => fetchSuggestions(limit),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
}
